/** Shared route metadata for Settings overview and navigation. */
export const SETTINGS_SECTIONS = [
  "profile",
  "security",
  "permissions",
  "connections",
  "embeds",
  "data",
  "transfer",
  "compute",
  "billing",
] as const;
export type SettingsSection = (typeof SETTINGS_SECTIONS)[number];
export const SETTINGS_SECTION_META: Record<
  SettingsSection,
  { title: string; desc: string }
> = {
  profile: { title: "Account", desc: "Your profile and account information." },
  security: {
    title: "Sign-in & security",
    desc: "Sign-in methods, passkeys and active devices.",
  },
  permissions: {
    title: "App permissions",
    desc: "What connected AI can do with each app.",
  },
  connections: {
    title: "Connected AI",
    desc: "AI connections and external services.",
  },
  embeds: { title: "Embedding", desc: "" },
  data: {
    title: "Data & storage",
    desc: "Your saved app data and storage usage.",
  },
  transfer: {
    title: "Transfer & backup",
    desc: "Copy or restore Personal Apps and their data.",
  },
  compute: {
    title: "Compute",
    desc: "Managed compute for apps that cannot run directly in your browser.",
  },
  billing: {
    title: "Plan & billing",
    desc: "Your plan, app access and billing.",
  },
};
// Preserve the historical account URL: it previously contained sign-in settings.
const SETTINGS_SECTION_ALIASES: Record<string, SettingsSection> = {
  account: "security",
};
export function isSettingsSection(value: string): value is SettingsSection {
  return (SETTINGS_SECTIONS as readonly string[]).includes(value);
}
export function resolveSettingsSection(value: string): SettingsSection | null {
  return isSettingsSection(value)
    ? value
    : (SETTINGS_SECTION_ALIASES[value] ?? null);
}
